 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"ForgotPassword":"ForgotPassword","Integrations":"Integrations","Login":"Login","PayoutsConfiguration":"PayoutsConfiguration","Profile":"Profile","ProfileConfiguration":"ProfileConfiguration","RemotePaymentHome":"RemotePaymentHome","ResetPassword":"ResetPassword","SalesReportHome":"SalesReportHome","SetupPassword":"SetupPassword","SupportForm":"SupportForm","UnlockAccount":"UnlockAccount","DailyTransactionsStatement":"DailyTransactionsStatement","PendingPayouts":"PendingPayouts","StaffHome":"StaffHome","TransactionHistory":"TransactionHistory","Transferences":"Transferences","Withdrawals":"Withdrawals","RemotePayments.vue":"RemotePayments.vue","ScanToPay":"ScanToPay","Balance":"Balance"}[chunkId]||chunkId) + "." + {"ForgotPassword":"c422f1f2","Integrations":"0f6ac65c","Login":"b56d87eb","PayoutsConfiguration":"0b94e6a9","Profile":"3338b746","ProfileConfiguration":"cc82ad5b","RemotePaymentHome":"bd7ccbeb","ResetPassword":"29a09a9c","SalesReportHome":"5567f8ee","SetupPassword":"7d0f3c7c","SupportForm":"bea13b51","UnlockAccount":"31d8ff09","chunk-0a0c1ccc":"e21b0b1e","DailyTransactionsStatement":"a3a6bf32","PendingPayouts":"e5c94e1a","StaffHome":"1d75042e","TransactionHistory":"6927982b","Transferences":"dfdc6286","Withdrawals":"235ffc96","chunk-4482533f":"40556c99","chunk-1023337a":"989b069c","chunk-99e3824a":"d6738866","RemotePayments.vue":"6b6cd09d","chunk-5aba95f0":"ae41e4f6","chunk-f9513486":"c5a18b34","ScanToPay":"b3af7f18","chunk-8bc12cc4":"9a3e60f5","Balance":"3d22d367","chunk-3df7b52b":"e46b9ddf","chunk-bcfc6f50":"172660b7","chunk-7a543586":"c7968619","chunk-7b9b1422":"861ce710","chunk-9b53c68e":"4adc1d14","chunk-1f669684":"d45c483a","chunk-3f4898c3":"3f0c368e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"ForgotPassword":1,"Integrations":1,"Login":1,"PayoutsConfiguration":1,"Profile":1,"ProfileConfiguration":1,"RemotePaymentHome":1,"ResetPassword":1,"SalesReportHome":1,"SetupPassword":1,"SupportForm":1,"UnlockAccount":1,"chunk-0a0c1ccc":1,"DailyTransactionsStatement":1,"PendingPayouts":1,"StaffHome":1,"TransactionHistory":1,"Transferences":1,"Withdrawals":1,"chunk-4482533f":1,"chunk-1023337a":1,"chunk-99e3824a":1,"RemotePayments.vue":1,"chunk-5aba95f0":1,"chunk-f9513486":1,"ScanToPay":1,"Balance":1,"chunk-3df7b52b":1,"chunk-bcfc6f50":1,"chunk-7a543586":1,"chunk-7b9b1422":1,"chunk-9b53c68e":1,"chunk-1f669684":1,"chunk-3f4898c3":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"ForgotPassword":"ForgotPassword","Integrations":"Integrations","Login":"Login","PayoutsConfiguration":"PayoutsConfiguration","Profile":"Profile","ProfileConfiguration":"ProfileConfiguration","RemotePaymentHome":"RemotePaymentHome","ResetPassword":"ResetPassword","SalesReportHome":"SalesReportHome","SetupPassword":"SetupPassword","SupportForm":"SupportForm","UnlockAccount":"UnlockAccount","DailyTransactionsStatement":"DailyTransactionsStatement","PendingPayouts":"PendingPayouts","StaffHome":"StaffHome","TransactionHistory":"TransactionHistory","Transferences":"Transferences","Withdrawals":"Withdrawals","RemotePayments.vue":"RemotePayments.vue","ScanToPay":"ScanToPay","Balance":"Balance"}[chunkId]||chunkId) + "." + {"ForgotPassword":"74f6ef4d","Integrations":"496b55e9","Login":"86cca97c","PayoutsConfiguration":"460975bf","Profile":"4eadbdfa","ProfileConfiguration":"b2cb661a","RemotePaymentHome":"ebc4a96a","ResetPassword":"e40a17e7","SalesReportHome":"d34c68a2","SetupPassword":"96e2215a","SupportForm":"5d1dac7f","UnlockAccount":"5953a750","chunk-0a0c1ccc":"237e60d9","DailyTransactionsStatement":"02e50fea","PendingPayouts":"827d79f7","StaffHome":"161ae551","TransactionHistory":"de5926c6","Transferences":"95169cf9","Withdrawals":"27cd11ef","chunk-4482533f":"655c770b","chunk-1023337a":"5b842488","chunk-99e3824a":"18f7900b","RemotePayments.vue":"c91e3d90","chunk-5aba95f0":"9ef21a9f","chunk-f9513486":"32a09222","ScanToPay":"eca52554","chunk-8bc12cc4":"31d6cfe0","Balance":"9c86d922","chunk-3df7b52b":"496b55e9","chunk-bcfc6f50":"2ced1e2f","chunk-7a543586":"d649531f","chunk-7b9b1422":"57eff909","chunk-9b53c68e":"4eb92784","chunk-1f669684":"dba7608f","chunk-3f4898c3":"27cd11ef"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
